module.exports = __webpack_public_path__ + "static/media/Cooleaf-Vote.8aa75daf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Cooleaf/Cooleaf-Vote.gif
// module id = 131
// module chunks = 0